// extracted by mini-css-extract-plugin
export default {"botonExport":"ExportPDF_botonExport__40OQ3","spinner":"ExportPDF_spinner__Iw93F","spin":"ExportPDF_spin__DHOp8"};